import { render, staticRenderFns } from "./BomForm.vue?vue&type=template&id=443f4154&"
import script from "./BomForm.vue?vue&type=script&lang=js&"
export * from "./BomForm.vue?vue&type=script&lang=js&"
import style0 from "./BomForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports